/** Display-only liveness. A historical running tool is not a running process receipt. */
export function messageTurnIsActive(
  message: { id: string; isStreaming?: boolean },
  status: { busy?: boolean; state?: string } | undefined,
  streamingMessageId: string | null | undefined,
) {
  if (!message.isStreaming || message.id !== streamingMessageId) return false;
  // Missing status during initial connection is not evidence that work stopped.
  return status?.busy !== false && !["idle", "killing", "errored"].includes(status?.state ?? "");
}
